import { useState } from "react";
import Button from "../shared/buttons/button";
import SelectHospitalsModal from "./SelectHospitalsModal";

export default function HospitalCoveragePicker({
  hospitalIds = [],
  onChange,
  error,
  stateGroups = [],
  isLoading = false,
  currentDistributorId = null,
  hideAssignedTab = false,
}) {
  const [showModal, setShowModal] = useState(false);
  const count = Array.isArray(hospitalIds) ? hospitalIds.filter(Boolean).length : 0;

  return (
    <div className="hospital-coverage-picker mb-3">
      <label className="cmn_label d-block mb-2">
        States &amp; Hospitals <span className="text-danger">*</span>
      </label>
      <div className="hospital-coverage-picker__row">
        <Button
          label="Select hospitals"
          className="cancel"
          onClick={() => setShowModal(true)}
        />
        <span className="hospital-coverage-picker__summary">
          {isLoading
            ? "Loading hospitals…"
            : `${count} hospital${count === 1 ? "" : "s"} selected`}
        </span>
      </div>
      {error ? <p className="text-danger small mb-0 mt-2">{error}</p> : null}
      <SelectHospitalsModal
        show={showModal}
        setShow={setShowModal}
        hospitalIds={hospitalIds}
        onConfirm={onChange}
        stateGroups={stateGroups}
        isLoading={isLoading}
        currentDistributorId={currentDistributorId}
        hideAssignedTab={hideAssignedTab}
      />
    </div>
  );
}
